import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import { logoutUserSuccess } from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Permission (quyền route/menu + button/input của user hiện tại) - ADDED, xem mục 9, README_SERCURITY.md
import PermissionReducer from "./permission/reducer";

// Dashboard Analytics
import DashboardAnalyticsReducer from "./dashboardAnalytics/reducer";

// Dashboard Ecommerce
import DashboardEcommerceReducer from "./dashboardEcommerce/reducer";

// Audit Logs - ADDED
import AuditLogsReducer from "./auditLogs/reducer";

// User Management - ADDED
import UserManagementReducer from "./userManagement/reducer";

// Role Management - ADDED
import RoleManagementReducer from "./roleManagement/reducer";

// System Configuration - ADDED
import SystemConfigurationReducer from "./systemConfiguration/reducer";

// Branding Configuration - ADDED
import BrandingConfigurationReducer from "./brandingConfiguration/reducer";

// Brand Management - ADDED
import BrandManagementReducer from "./brandManagement/reducer";

// Agent Management - ADDED
import AgentManagementReducer from "./agentManagement/reducer";

// Tenant Management - ADDED
import TenantManagementReducer from "./tenantManagement/reducer";

// Ticket Design Template - ADDED
import TicketDesignTemplateReducer from "./ticketDesignTemplate/reducer";

// Ticket Type Management - ADDED
import TicketTypeReducer from "./ticketType/reducer";

// Sinh Bộ Số & QR - ADDED
import SinhBoSoQrReducer from "./sinhBoSoQr/reducer";

// Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
import PrizeStructureReducer from "./prizeStructure/reducer";

// Draw Result Management (Kết quả Quay số) - ADDED
import DrawResultReducer from "./drawResult/reducer";

// Notification Management - ADDED
import NotificationsReducer from "./notifications/reducer";

// User Profile - ADDED
import UserProfileReducer from "./userProfile/reducer";

// Module Management (quản lý module cha/con) - ADDED
import ModuleManagementReducer from "./moduleManagement/reducer";

// Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED
import ClaimDossierReducer from "./claimDossier/reducer";

// Giao vé cho đại lý (README_TICKETHANDLE.md mục 4) - ADDED
import TicketDeliveryReducer from "./ticketDelivery/reducer";

// Thu hồi vé ế — công ty tự rút vé khỏi kho tổng (REQUIRE_FIXBUGS.md mục 13.3) - ADDED
import TicketRecallReducer from "./ticketRecall/reducer";

// Yêu cầu hoàn vé ế tại quầy (US-016/US-017) - ADDED
import UnsoldTicketReturnReducer from "./unsoldTicketReturn/reducer";

// Thẩm định phiếu đối soát thu hồi vé ế (US-018) - ADDED — luồng cũ, không còn màn hình dùng
// (xem mục 22, REQUIRE_FIXBUGS.md), giữ nguyên reducer/API để không phá dữ liệu/type cũ.
import TicketReturnAppraisalReducer from "./ticketReturnAppraisal/reducer";

// Thẩm định thu hồi vé ế (mục 22, REQUIRE_FIXBUGS.md) — luồng CHUẨN, dựa trên TicketRecall
import TicketRecallAppraisalReducer from "./ticketRecallAppraisal/reducer";

// Lưu trữ vật lý & báo cáo nhanh thu hồi vé ế (US-019) - ADDED
import TicketReturnWarehouseReportReducer from "./ticketReturnWarehouseReport/reducer";

// Quản lý Nhà in (README.md mục 7 — module IssuanceReporting). Các trang báo cáo (RPT-001→018)
// không có slice riêng — chỉ đọc/gọi thẳng API, xem pages/Reports/IssuanceReporting.
import PrintHouseReducer from "./printHouse/reducer";

const appReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Permission: PermissionReducer,
    DashboardAnalytics: DashboardAnalyticsReducer,
    DashboardEcommerce: DashboardEcommerceReducer,
    AuditLogs: AuditLogsReducer,
    UserManagement: UserManagementReducer,
    RoleManagement: RoleManagementReducer,
    SystemConfiguration: SystemConfigurationReducer,
    BrandingConfiguration: BrandingConfigurationReducer,
    BrandManagement: BrandManagementReducer,
    AgentManagement: AgentManagementReducer,
    TenantManagement: TenantManagementReducer,
    TicketDesignTemplate: TicketDesignTemplateReducer,
    TicketType: TicketTypeReducer,
    SinhBoSoQr: SinhBoSoQrReducer,
    PrizeStructure: PrizeStructureReducer,
    DrawResult: DrawResultReducer,
    Notifications: NotificationsReducer,
    UserProfile: UserProfileReducer,
    ModuleManagement: ModuleManagementReducer,
    ClaimDossier: ClaimDossierReducer,
    TicketDelivery: TicketDeliveryReducer,
    TicketRecall: TicketRecallReducer,
    UnsoldTicketReturn: UnsoldTicketReturnReducer,
    TicketReturnAppraisal: TicketReturnAppraisalReducer,
    TicketRecallAppraisal: TicketRecallAppraisalReducer,
    TicketReturnWarehouseReport: TicketReturnWarehouseReportReducer,
    PrintHouse: PrintHouseReducer

});

export type RootState = ReturnType<typeof appReducer>;

// Reset toàn bộ Redux store về initial state khi logout — nếu không, những slice cache dữ liệu
// theo user (VD UserProfile.profile) sẽ vẫn giữ nguyên dữ liệu tài khoản cũ khi đăng nhập lại
// bằng tài khoản khác trong cùng phiên SPA (không có full page reload), phải bấm F5 mới thấy đúng.
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
    if (action.type === logoutUserSuccess.type) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
